import { heroStats, siteMeta, tickerItems } from '@/mocks/home';

export default function HeroSection() {
  return (
    <section id="home" className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20night%20cityscape%20of%20a%20glowing%20entertainment%20district%20with%20neon%20signage%2C%20wide%20editorial%20photograph%2C%20deep%20shadows%20and%20warm%20amber%20highlights%2C%20moody%20atmosphere%2C%20high%20contrast%2C%20artistic%20abstract%20composition%20with%20strong%20negative%20space%20for%20text%20overlay&width=1600&height=900&seq=hlzq-hero-01&orientation=landscape"
          alt="夜色中的娱乐街区，暖色灯光与深色阴影形成强烈对比"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/65 to-foreground-950/92"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-8xl flex-col justify-center px-4 pb-14 pt-28 md:px-8 md:pb-20 md:pt-40">
        <div className="animate-rise max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-accent-500/50 bg-accent-500/10 px-3 py-1.5 text-xs tracking-[0.18em] text-accent-200">
            <i className="ri-fire-line text-accent-400"></i>
            娱乐内情观察 · 每日更新
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl lg:text-6xl">
            {siteMeta.name}
            <span className="mt-3 block text-xl font-semibold text-background-200 md:text-3xl">
              深扒内情，深挖事件背后的真实链路
            </span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-200 md:text-base">
            {siteMeta.description}
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
            >
              <i className="ri-fire-line"></i>
              查看本周深扒榜
            </a>
            <a
              href="#articles"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-50/35 px-6 py-3.5 text-sm font-medium text-background-50 whitespace-nowrap transition-colors hover:bg-background-50/12"
            >
              <i className="ri-article-line"></i>
              阅读精选内容
            </a>
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-x-4 gap-y-6 border-t border-background-50/15 pt-8 md:mt-16 md:grid-cols-4 md:gap-6">
          {heroStats.map((stat) => (
            <div key={stat.id}>
              <dt className="text-xs text-background-300 md:text-sm">{stat.label}</dt>
              <dd className="mt-2 font-heading text-2xl font-bold text-background-50 md:text-3xl">
                {stat.value}
                <span className="ml-1 text-xs font-normal text-accent-400 md:text-sm">
                  {stat.suffix}
                </span>
              </dd>
            </div>
          ))}
        </dl>
      </div>

      <div className="relative border-y border-background-50/12 bg-foreground-950/85">
        <div className="flex items-center gap-4 overflow-hidden py-3">
          <span className="ml-4 hidden shrink-0 items-center gap-2 rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 md:inline-flex">
            <i className="ri-pulse-line"></i>
            实时关注
          </span>
          <div className="flex w-max animate-ticker items-center">
            {[...tickerItems, ...tickerItems].map((text, index) => (
              <span
                key={`${text}-${index}`}
                className="flex items-center whitespace-nowrap px-6 text-xs text-background-300 md:text-sm"
              >
                <i className="ri-circle-fill mr-3 text-[6px] text-accent-500"></i>
                {text}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}